<template>
  <div style="max-width: 900px">
    <ValidationObserver ref="form">
      <form>
        <div class="form-group row">
          <label for="" class="col-sm-3"><span/> 姓名 <span class="require" v-if="formDataValidate.Name" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Name" v-slot="{ errors }" name="姓名">
              <input type="text" class="form-control" placeholder="" v-model="formData.Name" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label for="" class="col-sm-3"><span/> date <span class="require" v-if="formDataValidate.Date" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Date" v-slot="{ errors }" name="date">
              <input type="text" class="form-control" placeholder="" v-model="formData.Date" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-10">
            <a class="btn btn-primary mybutton" @click.prevent="submit">確定</a>
<!--            <a class="btn btn-primary mybutton" @click.prevent="clone">複製到下一筆功能</a>-->
            <a class="btn btn-danger mybutton" @click.prevent="reset">取消</a>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>/**

 **/
import util from "@/util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import veeHelper from "@/util/veeHelper";

let returnRouter="CheckInAdminCrudIndex";

export default {
  data: function () {
    return {
      SystemId: "",
      type: "",
      formData: {
        Name: "",
        Date:"",
      },
      formDataValidate: {
        Name: "required",
        Date:"required",
      },
    };
  },
  watch:{
    '$route'(to,from){// eslint-disable-line
      this.SystemId=this.$route.query.SystemId
      this.type=this.$route.query.type

      this.getItem()
      this.$forceUpdate();
    },
  },
  methods: {
    getItem:function(){
      let that=this

      let loader=util.ShowLoading(this);
      apiAdmin.api_getContentBySystemId(this.SystemId).then((data)=>{
        that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,that.formData);

        util.HideLoading(loader);
      });
    },
    submit:function(){
      let that=this
      let router=this.$router


      this.$refs.form.validateWithInfo().then(({ isValid, errors }) => {
        if (!isValid) {
          let errorMsg=veeHelper.VeeGetErrorMsgAllStr(errors);
          util.ShowMessage('部分資料未填寫完整'  +"<br/>" +errorMsg)
          return;
        }else{

          //---------------------------------------
          apiAdmin.api_saveContentBySystemId(that.type,that.SystemId,that.formData).then(()=>{
            util.ShowMessage('儲存成功')
            router.push({ name: returnRouter, query: { type: that.type }})
          })
          //---------------------------------------
          // Wait until the models are updated in the UI
          that.$nextTick(() => {
            that.$refs.form.reset();
          });
        }
      });

    },
    reset:function(){
      this.$router.push({ name: returnRouter, query: { type: this.type }})
    },
  },
  mounted() {
    this.SystemId=this.$route.query.SystemId
    this.type=this.$route.query.type

    this.getItem()
  },
}
</script>

<style scoped>

</style>
